import { h, Component } from 'preact';
import { route } from 'preact-router';
import { BaseComponent } from '../../common/BaseComponent';

import List from 'preact-material-components/List';
import { IWorkRequestListProps, IWorkRequestListState } from './IWorkRequestList';
import { bind } from 'decko';
import { WorkRequest } from '../../models/WorkRequest';
import { WorkRequestComponent } from './WorkRequestComponent';

let style = require('./style.scss');

export class WorkRequestList extends BaseComponent<IWorkRequestListProps, IWorkRequestListState> {

    constructor(props, ctx) {
        super(props, ctx);
        this.init(this.props);
    }

    @bind
    public onSelect(w: WorkRequest) {
        route('/workrequests/' + w.id, true);
    }

    public init(p) {
        if (p.workRequestId) {
            var workrequest = p.workRequests.filter(w => w.id == p.workRequestId)[0];
            if (!workrequest) {
                this.setState({
                    workRequestId: 0,
                    workRequest: undefined
                });
            }
            else
                this.setState({
                    workRequestId: p.workRequestId,
                    workRequest: workrequest
                });
        }
        else
            this.setState({
                workRequestId: p.workRequestId,
                workRequest: undefined
            });
    }

    componentWillReceiveProps(p) {
        this.init(p);
    }

    render() {
        return (<div class={style.workRequestList}>
            {this.state.workRequestId ? (<WorkRequestComponent
                workRequest={this.state.workRequest}
                actionButtons={this.props.actionButtons}
                buildingId={this.props.buildingId}
                onRefresh={this.props.onRefresh}
            />) : (

                    <List two-line={true}>
                        {this.props.workRequests.map(w => {
                            return <span><List.Item onClick={() => this.onSelect(w)}>
                                <List.TextContainer>
                                    <List.PrimaryText>{w.jobCode}</List.PrimaryText><br />
                                    <List.SecondaryText>{`${w.levelName} - ${w.tenantName}`}<br />{w.type}</List.SecondaryText>
                                </List.TextContainer>
                                <List.ItemMeta>chevron_right</List.ItemMeta>
                            </List.Item>
                                <List.Divider />
                            </span>
                        })}
                    </List>

                )}
        </div>);
    }
}


// WEBPACK FOOTER //
// ./components/WorkRequests/WorkRequestList.tsx